export default __webpack_public_path__ + "static/media/track.aa25f8cc.png";